import { gql, type TypedDocumentNode } from "@apollo/client";
import type { SectionGovernanceTargetType } from "./sectionGovernanceQueries";

interface GovernanceRoleMutationResult {
  success: boolean;
  message: string;
  governanceRole?: {
    id: string;
    status: string;
  } | null;
}

export interface GovernanceRoleNoteInput {
  content: string;
  priority: string;
  title?: string;
}

export interface CreateGovernanceRoleMutationVariables {
  input: {
    personId: string;
    governableId: string;
    governableType: SectionGovernanceTargetType;
    governanceTitleId: string;
    note?: GovernanceRoleNoteInput | null;
  };
}

export interface CreateGovernanceRoleMutationData {
  createGovernanceRole: GovernanceRoleMutationResult;
}

export const CREATE_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  CreateGovernanceRoleMutationData,
  CreateGovernanceRoleMutationVariables
> = gql`
  mutation CreateGovernanceRole($input: BackofficeCreateGovernanceRoleInput!) {
    createGovernanceRole(input: $input) {
      success
      message
      governanceRole {
        id
        status
      }
    }
  }
`;

export interface UpdateGovernanceRoleMutationData {
  updateGovernanceRole: GovernanceRoleMutationResult;
}

export interface UpdateGovernanceRoleMutationVariables {
  input: {
    id: string;
    governanceTitleId: string;
    note?: GovernanceRoleNoteInput | null;
  };
}

export const UPDATE_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  UpdateGovernanceRoleMutationData,
  UpdateGovernanceRoleMutationVariables
> = gql`
  mutation UpdateGovernanceRole($input: BackofficeUpdateGovernanceRoleInput!) {
    updateGovernanceRole(input: $input) {
      success
      message
      governanceRole {
        id
        status
      }
    }
  }
`;

export interface ArchiveGovernanceRoleMutationData {
  archiveGovernanceRole: GovernanceRoleMutationResult;
}

export interface ArchiveGovernanceRoleMutationVariables {
  id: string;
}

export const ARCHIVE_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  ArchiveGovernanceRoleMutationData,
  ArchiveGovernanceRoleMutationVariables
> = gql`
  mutation ArchiveGovernanceRole($id: ID!) {
    archiveGovernanceRole(id: $id) {
      success
      message
      governanceRole {
        id
        status
      }
    }
  }
`;

export interface UnarchiveGovernanceRoleMutationData {
  unarchiveGovernanceRole: GovernanceRoleMutationResult;
}

export interface UnarchiveGovernanceRoleMutationVariables {
  id: string;
}

export const UNARCHIVE_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  UnarchiveGovernanceRoleMutationData,
  UnarchiveGovernanceRoleMutationVariables
> = gql`
  mutation UnarchiveGovernanceRole($id: ID!) {
    unarchiveGovernanceRole(id: $id) {
      success
      message
      governanceRole {
        id
        status
      }
    }
  }
`;
